import { render, staticRenderFns } from "./span-input.vue?vue&type=template&id=f9d6deb0&"
import script from "./span-input.vue?vue&type=script&lang=js&"
export * from "./span-input.vue?vue&type=script&lang=js&"
import style0 from "./span-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports